import { PARTY_ROUTES } from '@features/onboarding/routes';
import { PartyCaseStatus } from '@g2-shared/api-client/generated/onboarding-app';
import { LoadingScreen } from '@g2-shared/components';
import { useFindPartyBySelfUser, useFindPartyCaseByServiceCodeForUser } from '@g2-shared/features';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

interface Props {
  children: React.ReactNode;
}

export const OnboardingGuard = ({ children }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading: isLoadingParty, party } = useFindPartyBySelfUser();
  const { partyCase, isLoading: isLoadingPartyCase } = useFindPartyCaseByServiceCodeForUser(
    'WUD',
    true
  );

  useEffect(() => {
    if (!party && !isLoadingParty) {
      navigate(PARTY_ROUTES.createParty);
    }
  }, [isLoadingParty, location.pathname, party]);

  useEffect(() => {
    if (
      !isLoadingParty &&
      !isLoadingPartyCase &&
      party &&
      (!partyCase || partyCase.status !== PartyCaseStatus.COMPLETED)
    ) {
      navigate(PARTY_ROUTES.processPartyCase);
    }
  }, [party, partyCase, isLoadingPartyCase, isLoadingParty, location.pathname]);

  useEffect(() => {
    if (
      !!party &&
      !!partyCase &&
      partyCase.status === PartyCaseStatus.COMPLETED &&
      (location.pathname === PARTY_ROUTES.processPartyCase ||
        location.pathname === PARTY_ROUTES.createParty)
    ) {
      navigate('/');
    }
  }, [party, partyCase]);

  if (!party && !partyCase && (isLoadingParty || isLoadingPartyCase)) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};
